const courses = [
  {
    title: 'Statistical Learning I & II',
    number: 'ECE 271A/B',
    link: 'https://catalog.ucsd.edu/courses/ECE.html?#ece271a',
    university: 'UC San Diego',
  },
  {
    title: 'Digital Image Processing',
    number: 'ECE 253',
    link: 'https://catalog.ucsd.edu/courses/ECE.html?#ece253',
    university: 'UC San Diego',
  },
  {
    title: 'Programming for Data Analysis',
    number: 'ECE 143',
    link: 'https://catalog.ucsd.edu/courses/ECE.html?#ece143',
    university: 'UC San Diego',
  },
  {
    title: 'Linear Algebra & Application',
    number: 'ECE 269',
    link:
      'https://catalog.ucsd.edu/courses/ECE.html?#ece269',
    university: 'UC San Diego',
  },
  {
    title: 'Introduction to Visual Learning',
    number: 'ECE 285',
    link: 'https://catalog.ucsd.edu/courses/ECE.html?#ece285',
    university: 'UC San Diego',
  },
  {
    title: 'Machine Learning for Physical Applications',
    number: 'ECE 228',
    link: 'https://catalog.ucsd.edu/courses/ECE.html?#ece228',
    university: 'UC San Diego',
  },
  {
    title: 'GPU Programming',
    number: 'ECE 277',
    link:
      'https://catalog.ucsd.edu/courses/ECE.html?#ece277',
    university: 'UC San Diego',
  },
  {
    title: 'Principles of Medical Imaging',
    number: 'ECE 207A',
    link: 'https://catalog.ucsd.edu/courses/ECE.html?#ece207a',
    university: 'UC San Diego',
  },
  {
    title: 'Filterbanks and Wavelets',
    number: 'ECE 251C',
    link: 'https://catalog.ucsd.edu/courses/ECE.html?#ece251C',
    university: 'UC San Diego',
  },
  {
    title: 'Digital Signal Processing',
    number: 'ECE 251A',
    link: 'https://catalog.ucsd.edu/courses/ECE.html?#ece251a',
    university: 'UC San Diego',
  },
  {
    title: 'Deep Learning & Applications',
    number: 'ECE 176',
    link: 'https://catalog.ucsd.edu/courses/ECE.html?#ece176',
    university: 'UC San Diego',
  },
];

export default courses;
